// src/api/apiCities.js
import axios from "../utils/axios";

/// Get Cities
export const getAllCities = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("cities", { params });
    return data;
};

/// Get Cities for Select Dropdown
export const getCitiesForSelect = async (countryId) => {
    try {
        const params = {};
        if (countryId) params.country_id = countryId;

        const { data } = await axios.get("cities/for-select", { params });
        return data;
    } catch (error) {
        console.error("getCitiesForSelect error:", error);
        throw error;
    }
};

/// Get City
export const getCity = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`cities/${id}`);
    return data;
};

/// Create City
export const createCity = async (req) => {
    try {
        const { data } = await axios.post("cities", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createCity error:", error);
        throw error;
    }
};

/// Update City
export const updateCity = async (req, id) => {
    try {
        const { data } = await axios.put(`cities/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateCity error:", error);
        throw error;
    }
};

/// Delete City
export const deleteCity = async (id) => {
    try {
        const { data } = await axios.delete(`cities/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteCity error:", error);
        throw error;
    }
};

/// Delete All Cities
export const deleteAllCities = async (ids = []) => {
    try {
        const { data } = await axios.delete("cities/mass-destroy", {
            data: { items: ids },
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteAllCities error:", error);
        throw error;
    }
};

/// Force Delete City
export const forceDeleteCity = async (id) => {
    try {
        const { data } = await axios.delete(`cities/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteCity error:", error);
        throw error;
    }
};

/// Force Delete All Cities
export const forceDeleteAllCities = async (ids = []) => {
    try {
        const { data } = await axios.delete("cities/mass-force-delete", {
            data: { items: ids },
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteAllCities error:", error);
        throw error;
    }
};

/// Restore City
export const restoreCity = async (id) => {
    try {
        const { data } = await axios.post(`cities/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreCity error:", error);
        throw error;
    }
};

/// Restore All Cities
export const restoreAllCities = async (ids = []) => {
    try {
        const { data } = await axios.post("cities/mass-restore", { items: ids }, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreAllCities error:", error);
        throw error;
    }
};
